export enum JOBS_QUEUE_STATUS {
  IDLE = 'IDLE',
  IN_PROGRESS = 'IN_PROGRESS',
  NO_QUEUE = 'NO_QUEUE',
}
